import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tszg5uwbyq: FaireBrandEntity = {
  token: "b_tszg5uwbyq",
  type: "brand",
  name: "Britt Mills Design",
  avatarUrl:
    "https://cdn.faire.com/fastly/d8baff1a0a9ce415100ebbe597c3c982340efd89cae681c32ec6ad877abed550.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0cde0dba4afdf54699c7bf3a21bcc41a0d3968ed3a0cecd565cb36f885086c34.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d8baff1a0a9ce415100ebbe597c3c982340efd89cae681c32ec6ad877abed550.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0cde0dba4afdf54699c7bf3a21bcc41a0d3968ed3a0cecd565cb36f885086c34.jpeg",
  location: "Bradenton, FL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 10,
  isInsider: true,
  description:
    "Britt Mills Design celebrates timeless design through a modern lens. Rooted in classic Southern style and heritage aesthetics, the brand reimagines tradition with fresh color, playful scale, and confident pattern play. This is heirloom-inspired artwork made for today—designed to feel collected, expressive, and joyfully elevated. \n\nHer work can be found at Target, Pottery Barn Teen, Staples, and MUSE.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:56.484Z",
    importedBy: "entity-db-cli",
  },
};
